import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { getPersonalizationAccess } from 'personalization-lib/utils/auth';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AccessBoundary = ({
  children,
  fallback,
  requiresWrite = false
}) => {
  const {
    view,
    edit
  } = getPersonalizationAccess();
  const hasAccess = requiresWrite ? view && edit : view;
  if (!hasAccess) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: fallback !== null && fallback !== void 0 ? fallback : /*#__PURE__*/_jsx(ErrorMessage, {
        "data-test-id": "access-boundary-no-permissions",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "personalizationLib.shared.boundaries.accessBoundary.noPermissions.title"
        }),
        children: !view ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "personalizationLib.shared.boundaries.accessBoundary.noPermissions.message.view"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "personalizationLib.shared.boundaries.accessBoundary.noPermissions.message.create"
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default AccessBoundary;